export default function resizeImage(src, width, height) {
  const imageType = src.split(/[#?]/)[0].split(".").pop().trim();
  if (imageType === "gif") return src;

  return `/resize?url=${encodeURIComponent(
    src
  )}&width=${width}&height=${height}`;
}
